import { useContext } from "react";
import { EventWebsocketContext } from "../contexts/EventWebsocketContext";

export const useEventWebsocket = () => {
  const { sendEvent, readyState, sendPreviewEvent } = useContext(
    EventWebsocketContext
  );
  return { sendEvent, readyState, sendPreviewEvent };
};
